module.exports = __webpack_public_path__ + "img/Photobooth.507e41d.jpg";